import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const Success = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/student/home", {
      replace: true,
      state: { paymentResult: "success" },
    });
  }, [navigate]);

  return null;
};

export default Success;
